// extracted by mini-css-extract-plugin
export default {"root":"dev-mode-indicator_root__MjmKu"};